import React from "react";
import { useSelector } from "react-redux";

export default function BasketIcon({ size = 50, color = "#ffffff" }) {

	const itemCount = useSelector(state => state.basket.items.reduce((acc, item) => acc += item.quantity, 0));

	return <span className="basketIcon" style={{
		height: size,
		width: size
	}}>
		<svg version="1.1" id="Layer_1" x="0px" y="0px"
			viewBox="0 0 28 28" space="preserve">
			<path id="Union_3" style={{ fill: color }} d="M15.5,18.8c0-0.8,0.6-1.4,1.5-1.4c0.8,0,1.4,0.6,1.4,1.5c0,0.8-0.6,1.4-1.5,1.4
	C16.1,20.2,15.4,19.6,15.5,18.8z M16.4,18.8c0,0.3,0.3,0.5,0.5,0.5s0.5-0.3,0.5-0.5s-0.3-0.5-0.5-0.5C16.6,18.3,16.4,18.5,16.4,18.8
	z M9.9,18.8c0-0.8,0.6-1.4,1.5-1.4c0.8,0,1.4,0.6,1.4,1.5c0,0.8-0.6,1.4-1.4,1.4C10.6,20.2,9.9,19.6,9.9,18.8L9.9,18.8z M10.8,18.8
	c0,0.3,0.3,0.5,0.5,0.5s0.5-0.3,0.5-0.5s-0.2-0.5-0.5-0.5C11.1,18.3,10.8,18.5,10.8,18.8z M17.9,16.9h-7.6c-0.3,0-0.4-0.1-0.6-0.3
	c-0.3-0.1-0.4-0.3-0.4-0.6L7.6,9.5H6.2c-0.1,0-0.3-0.1-0.3-0.1C5.7,9.3,5.7,9.2,5.7,9c0-0.1,0.1-0.3,0.1-0.3C5.9,8.6,6,8.6,6.1,8.6
	h1.4c0.3,0,0.4,0.1,0.6,0.3C8.3,9,8.5,9.2,8.5,9.4l1.6,6.6h7.8l1.5-5.6h1l-1.5,5.7c-0.1,0.3-0.2,0.4-0.4,0.6
	C18.4,16.9,18.2,16.9,17.9,16.9L17.9,16.9z"/>
		</svg>
		<span className="count">
			{itemCount}
		</span>
	</span >
}